"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\t\t\thtml, body, #root {\n\t\t\t\twidth: 100% ;\n\t\t\t\theight: 100% ;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t*, *:before, *:after {\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\n\t\t\tbody {\n\t\t\t\tfont-family: Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif;\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\n\t\t\tdiv {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t}\n\n\t\t\th1, h2, h3, h4, h5, h6, p {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\ta, a:hover, a:visited, a:active, a:link {\n\t\t\t\tcolor: ", ";\n\t\t\t\ttext-decoration: none;\n\t\t\t}\n\t\t"], ["\n\t\t\thtml, body, #root {\n\t\t\t\twidth: 100% ;\n\t\t\t\theight: 100% ;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t*, *:before, *:after {\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\n\t\t\tbody {\n\t\t\t\tfont-family: Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif;\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\n\t\t\tdiv {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t}\n\n\t\t\th1, h2, h3, h4, h5, h6, p {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\ta, a:hover, a:visited, a:active, a:link {\n\t\t\t\tcolor: ", ";\n\t\t\t\ttext-decoration: none;\n\t\t\t}\n\t\t"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = require("react-apollo");

var _reactRouterDom = require("react-router-dom");

var _styledComponents = require("styled-components");

var _apolloClient = require("../../apolloClient");

var _theme = require("../../theme");

var _theme2 = _interopRequireDefault(_theme);

var _getJWT = require("../../getJWT");

var _getJWT2 = _interopRequireDefault(_getJWT);

var _sidebar = require("./sidebar");

var _sidebar2 = _interopRequireDefault(_sidebar);

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------

var defaultTheme = _theme2.default;
var defaultClient = _apolloClient.client;
var defaultRouter = _reactRouterDom.BrowserRouter;

//------------------------------

var renderContained = function renderContained(props) {
	return function () {
		return _react2.default.createElement(
			_styles.Container,
			null,
			_react2.default.createElement(_sidebar2.default, null),
			props.children
		);
	};
};

var AppRedirect = function AppRedirect() {
	return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/app" });
};

var Shell = function (_React$Component) {
	(0, _inherits3.default)(Shell, _React$Component);

	function Shell(props) {
		(0, _classCallCheck3.default)(this, Shell);

		/* eslint no-unused-expressions: 0 */

		var _this = (0, _possibleConstructorReturn3.default)(this, (Shell.__proto__ || Object.getPrototypeOf(Shell)).call(this, props));

		(0, _styledComponents.injectGlobal)(_templateObject, props.theme.colors.black, props.theme.colors.black);
		return _this;
	}

	(0, _createClass3.default)(Shell, [{
		key: "render",
		value: function render() {
			var Router = this.props.router;

			return _react2.default.createElement(
				_styledComponents.ThemeProvider,
				{ theme: this.props.theme },
				_react2.default.createElement(
					_reactApollo.ApolloProvider,
					{ client: this.props.client },
					_react2.default.createElement(
						Router,
						null,
						_react2.default.createElement(
							_reactRouterDom.Switch,
							null,
							_react2.default.createElement(_reactRouterDom.Route, {
								path: "/app/:orgID?",
								render: renderContained(this.props)
							}),
							_react2.default.createElement(_reactRouterDom.Route, { component: AppRedirect })
						)
					)
				)
			);
		}
	}]);
	return Shell;
}(_react2.default.Component);

Shell.defaultRouter = defaultRouter;
Shell.defaultClient = defaultClient;
Shell.defaultTheme = defaultTheme;
Shell.getJWT = _getJWT2.default;

Shell.defaultProps = {
	router: defaultRouter,
	client: defaultClient,
	theme: defaultTheme
};

exports.default = Shell;

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/index.js
// module id = 380
// module chunks = 0